function getChildren(obj) {
  let res = []
  obj?.map(item => {
    res.push(item)
    if (item.children?.length) {
      res = res.concat(getChildren(item.children))
    }
  })
  return res
}

const getters = {
  deviceMode: state => {
    const windowInnerWidth = state.common.windowInnerWidth
    return windowInnerWidth < 1024 ? 'mobile' : windowInnerWidth < 1366 ? 'pad' : 'pc'
  },
  actionAuthorityMap: state => {
    const { menuRoutes = [] } = state.menus
    const list = getChildren(menuRoutes)

    return list.reduce((res, item) => {
      res[item.code] = true
      return res
    }, {})
  },
  watermarkText: state => {
    const userInfo = state.systemUser.userInfo
    if (!userInfo || !userInfo.userName) {
      return ''
    }
    if (!userInfo.account) {
      return userInfo.userName || ''
    }
    let suffix = ''
    if (userInfo.account.length > 4) {
      suffix = userInfo.account.substring(userInfo.account.length - 4)
    }
    return userInfo.userName + suffix
  },
}
export default getters
